/**
 * Toggles body scroll lock for fullscreen overlays (mobile menu, account takeover).
 * Sets fixed positioning on document.body when locked, restores scroll position when unlocked.
 */
export const bodyScrollLock = (
  isLocked: boolean,
  lastScrollPosition: number,
) => {
  if (typeof document === 'undefined') {
    return;
  }
  const { body } = document;
  if (isLocked) {
    body.style.position = 'fixed';
    body.style.top = `-${lastScrollPosition}px`;
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    return;
  }

  body.style.position = '';
  body.style.top = '';
  body.style.width = '';
  body.style.overflow = '';
  window.scrollTo(0, lastScrollPosition);
};
